module.exports = __webpack_public_path__ + "img/mariana1.ae5e1bec.jpg";